"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncConvertToHTML = exports.asyncConvertFromHTML = exports.convertToHTML = exports.convertFromHTML = exports.toolbarConfig = exports.bodyEditorConfig = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _immutable = require("immutable");

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _draftExtend = require("draft-extend");

var _constants = require("composer-lib/lib/constants");

var _configurePlugins = require("composer-lib/lib/configurePlugins");

var _draftConvert = require("draft-convert");

var _PluginDropdownGroup = _interopRequireDefault(require("draft-plugins/plugins/PluginDropdownGroup"));

// our editor configuration for the body editor, applies all the necessary plugins
var bodyEditorConfig = function bodyEditorConfig(allowedRichTextStyles, allowedComposerFeatures) {
  var betas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var hasLinkPopoverBeta = betas.includes(_constants.Betas.LINK_POPOVER);

  var _configureStylePlugin = (0, _configurePlugins.configureStylePlugins)({
    allowedRichTextStyles: allowedRichTextStyles,
    options: options
  }),
      InlineStyles = _configureStylePlugin.InlineStyles,
      BlockStyles = _configureStylePlugin.BlockStyles;

  var composed = [InlineStyles, BlockStyles];

  if (allowedComposerFeatures[_constants.ComposerFeatures.CONVERSATIONS] || allowedComposerFeatures[_constants.ComposerFeatures.CHANGE]) {
    var HighlightPlugin = (0, _configurePlugins.configureHighlightPlugin)();
    composed.push(HighlightPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.LINK] || allowedComposerFeatures[_constants.ComposerFeatures.INSERT_TOOLS]) {
    if (hasLinkPopoverBeta) {
      var AdvancedLinkPlugin = (0, _configurePlugins.configureAdvancedLinkPlugin)({
        options: options
      });
      composed.push(AdvancedLinkPlugin);
    } else {
      var LinkPlugin = (0, _configurePlugins.configureLinkPlugin)({
        options: options
      });
      composed.push(LinkPlugin);
    }
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.VIDEO]) {
    var VideoPlugin = (0, _configurePlugins.configureVideoPlugin)({
      options: options
    });
    composed.push(VideoPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.IMAGE] || allowedComposerFeatures[_constants.ComposerFeatures.IMAGE_V2]) {
    if (allowedComposerFeatures[_constants.ComposerFeatures.IMAGE_V2]) {
      var AdvancedImagePlugin = (0, _configurePlugins.configureAdvancedImagePlugin)({
        options: options
      });
      composed.push(AdvancedImagePlugin);
    } else {
      var ImagePlugin = (0, _configurePlugins.configureImagePlugin)({
        options: options
      });
      composed.push(ImagePlugin);
    }

    var RemoveEmbeddedImagePlugin = (0, _configurePlugins.configureRemoveEmbeddedImagePlugin)({
      options: options
    });
    composed.push(RemoveEmbeddedImagePlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.CLIP]) {
    var ClipPlugin = (0, _configurePlugins.configureClipPlugin)({
      options: options
    });
    composed.push(ClipPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.CHANGE]) {
    var ChangePlugin = (0, _configurePlugins.configureChangePlugin)();
    composed.push(ChangePlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.EMBED]) {
    var EmbedPlugin = (0, _configurePlugins.configureEmbedPlugin)({
      options: options
    });
    composed.push(EmbedPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.QUESTION_AND_ANSWER]) {
    var QuestionAndAnswerPlugin = (0, _configurePlugins.configureQuestionAndAnswerPlugin)({
      options: options
    });
    composed.push(QuestionAndAnswerPlugin);
  }

  return _draftExtend.compose.apply(void 0, composed);
};

exports.bodyEditorConfig = bodyEditorConfig;

var toolbarConfig = function toolbarConfig(allowedRichTextStyles, allowedComposerFeatures) {
  var betas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var hasLinkPopoverBeta = betas.includes(_constants.Betas.LINK_POPOVER);

  var _configureStylePlugin2 = (0, _configurePlugins.configureStylePlugins)({
    allowedRichTextStyles: allowedRichTextStyles,
    options: options
  }),
      InlineStyles = _configureStylePlugin2.InlineStyles,
      BlockStyles = _configureStylePlugin2.BlockStyles,
      BlockStylesDropdown = _configureStylePlugin2.BlockStylesDropdown;

  var composed = [BlockStylesDropdown, InlineStyles, BlockStyles];
  var insertDropdownPlugins = [];

  if (allowedComposerFeatures[_constants.ComposerFeatures.LINK]) {
    if (hasLinkPopoverBeta) {
      var AdvancedLinkPlugin = (0, _configurePlugins.configureAdvancedLinkPlugin)({
        options: options
      });
      composed.push(AdvancedLinkPlugin);
    } else {
      var LinkPlugin = (0, _configurePlugins.configureLinkPlugin)({
        options: options
      });
      composed.push(LinkPlugin);
    }
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.IMAGE]) {
    var ImagePlugin = (0, _configurePlugins.configureImagePlugin)({
      options: options
    });
    composed.push(ImagePlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.IMAGE_V2]) {
    var AdvancedImagePlugin = (0, _configurePlugins.configureAdvancedImagePlugin)({
      options: options
    });
    composed.push(AdvancedImagePlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.QUESTION_AND_ANSWER]) {
    var QuestionAndAnswerPlugin = (0, _configurePlugins.configureQuestionAndAnswerPlugin)({
      options: options
    });
    composed.push(QuestionAndAnswerPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.VIDEO]) {
    var VideoPlugin = (0, _configurePlugins.configureVideoPlugin)({
      options: options
    });
    insertDropdownPlugins.push(VideoPlugin);
  }

  if (allowedComposerFeatures[_constants.ComposerFeatures.EMBED]) {
    var EmbedPlugin = (0, _configurePlugins.configureEmbedPlugin)({
      options: options
    });
    insertDropdownPlugins.push(EmbedPlugin);
  }

  var buttonText = _react.default.createElement(_FormattedMessage.default, {
    message: "composer-lib.insertTools.insert"
  });

  composed.push(_PluginDropdownGroup.default.apply(void 0, [{
    buttonText: buttonText
  }].concat(insertDropdownPlugins)));
  return _draftExtend.compose.apply(void 0, composed);
};

exports.toolbarConfig = toolbarConfig;

function hashEditorConfig(composerSettings, options) {
  var richTextStyleHash = new _immutable.Map(composerSettings.get('richTextStyles')).hashCode();
  var featuresHash = new _immutable.Map(composerSettings.get('features')).hashCode();
  var optionsHash = new _immutable.Map(options).hashCode();
  return "" + richTextStyleHash + featuresHash + optionsHash;
}

var getConvertFromHTML = (0, _memoize.default)(function (composerSettings) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return bodyEditorConfig(composerSettings.get('richTextStyles'), composerSettings.get('features'), composerSettings.get('betas'), options)(_draftConvert.convertFromHTML);
}, hashEditorConfig);
var getConvertToHTML = (0, _memoize.default)(function (composerSettings) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return bodyEditorConfig(composerSettings.get('richTextStyles'), composerSettings.get('features'), composerSettings.get('betas'), options)(_draftConvert.convertToHTML);
}, hashEditorConfig);
var convertFromHTML = getConvertFromHTML;
exports.convertFromHTML = convertFromHTML;
var convertToHTML = getConvertToHTML; // Same as previous set of functions but returns a promise to do conversion async

exports.convertToHTML = convertToHTML;

var asyncConvertFromHTML = function asyncConvertFromHTML(composerSettings, options) {
  return function (content) {
    return new Promise(function (resolve) {
      var converted = getConvertFromHTML(composerSettings, options)(content);
      resolve(converted);
    });
  };
};

exports.asyncConvertFromHTML = asyncConvertFromHTML;

var asyncConvertToHTML = function asyncConvertToHTML(composerSettings, options) {
  return function (content) {
    return new Promise(function (resolve) {
      var html = getConvertToHTML(composerSettings, options)(content);
      resolve(html);
    });
  };
};

exports.asyncConvertToHTML = asyncConvertToHTML;